<template>
  <div>
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            
            <div class="col-md-3">
              <label for="date">Disbursement Date From</label>
              <input type="date" v-model="form.disbursementStartDate" name="disbursementStartDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
            </div>
            <div class="col-md-3">
              <label for="date">Disbursement Date To</label>
              <input type="date" v-model="form.disbursementEndDate" name="disbursementEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment End Date">
            </div>
            <div class="col-md-3">
              <label for="date">EMI End Date From</label>
              <input type="date" v-model="form.startEmiEndDate" name="startEmiEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
            </div>
            <div class="col-md-3">
              <label for="date">EMI End Date To</label>
              <input type="date" v-model="form.endtEmiEndDate" name="endEmiEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
            </div>
            <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseCollectionCenter(branch, withChangeFilter = true)"></v-select>
              
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="canAccess('collection-center-create')">
              <label for="Branch">Group</label>
              <v-select v-model="collectionCenter"  name="collection_center_id" label="name" :options="colCenters" placeholder="Select Group" v-on:input="getRecordByCollectionCenter(collectionCenter)" required></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            
          </div>
          <div class="row">
            <div class="col-md-3">
              <button class="btn btn-info" @click="printViewDisbursementByCollectionCenter(status = 'disbursed')">Get Print</button>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('loan-disbursement-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Group Disbursement List</h3>
          
          <div class="box-tools">
            <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('member-create')">
              <i class="fa fa-plus"></i> Add New
            </button> -->
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr.</th>
                <th class="hidden-xs">Pl Name</th>
                <th class="hidden-xs">Pl Emi Type</th>
                <th>Plan Amt</th>
                <th class="hidden-xs">Dis Dt</th>
                <th class="hidden-xs">Emi Start Dt </th>
                <th class="hidden-xs">Emi End Dt </th>
                <th>Group</th>
                <th>Member</th>
                <th class="hidden-xs">Staff</th>
                <th class="hidden-xs">Pay Mode</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td class="hidden-xs">{{ planName(row.plan) }}</td>
                <td class="hidden-xs">{{ planRecoveryType(row.plan) }}</td>
                <td>{{ planAmt(row) }}</td>
                <td class="hidden-xs">{{ row.disbursementDate | myDate }}</td>
                <td class="hidden-xs">{{ row.emiStartDate | myDate }}</td>
                <td class="hidden-xs">{{ row.emiEndDate | myDate }}</td>
                <td>{{ row.collection_center.name }}</td>
                <td><i v-if="row.member">{{ row.member.name }}</i></td>
                <td class="hidden-xs"><span v-if="row.agent">{{ row.agent.name }}</span></td>
                <td class="hidden-xs">
                  {{row.branch_ledger.ledger.name}}
                </td>
                <td>
                  <div class="btn-group">
                    <button
                      v-if="canAccess('loan-disbursement-delete')"
                      v-show="row.status == 'disbursed' || row.status == 'pending'"
                      @click="deleteDisbursment(row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      v-show="row.filechargeStatus == 'exclude'"
                      @click="fileChargeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="File Charge"
                    >
                      <i class="fa fa-file"></i>
                    </button>
                    <button
                      v-show="row.processingFeeStatus == 'exclude'"
                      @click="processingFeeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="Processing Fee"
                    >
                      <i class="fa fa-hourglass"></i>
                    </button>
                    <button
                      v-show="row.insuranceFeeStatus == 'exclude'"
                      @click="insuranceFeeModal(row)"
                      class="btn btn-warning btn-xs"
                      title="Insurance Fee"
                    >
                      <i class="fa fa-user-md"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      
                      @click="viewPrintModal(row)"
                      title="For Staff"
                      class="btn btn-primary btn-xs"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="For Customer"
                      @click="viewPrintCustomerModal(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-hand-o-up"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="Loan EMI Card"
                      @click="viewPrintCustomerEMIModal(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-book"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="Dimand ProbeshnaryNote"
                      @click="viewPrintDimandProbeshnoryNote(row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-sticky-note-o"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.file-charge-modal -->
      <div class="modal fade" id="fileChargeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">File Charge</h4>
            </div>
            <form @submit.prevent="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect File Charge </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.processing-fee-modal -->
      <div class="modal fade" id="processingFeeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Processing Fee Charge</h4>
            </div>
            <form @submit.prevent="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect Processing Fee </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.insurance-fee-modal -->
      <div class="modal fade" id="insuranceFeeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Insurance Fee Charge</h4>
            </div>
            <form @submit.prevent.once="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect Insurance Fee </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="print()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            
            <div class="modal-body" id="print">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <!-- <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br> -->
                      <table class="table table-condensed">
                        <thead>
                          <td style="border-width:2px" width="18%"><img :src="logo" height="90"></td>
                          <td style="border-width:2px" class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td style="border-width:2px" class="text-right" width="20%"><barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <h1 class="text-center">Loan Application Form</h1>
                      <div v-if="seeRecord.status == 'disbursed'">
                      <table class="table table-condensed" style="border-width:2px">
                        <thead style="border-width:2px">
                          <th style="border-width:2px" colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th style="border-width:2px" colspan="2" class="text-right">Date : {{seeRecord.created_at | myDate}}</th>
                        </thead>
                        <tbody style="border-width:2px">
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Customer Name </td><td style="border-width:2px"> {{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td style="border-width:2px" rowspan="6" colspan="2">
                              <div style="border-width:3px;border-style:solid;width:140px;height:160px;float:right;text-align:center;"><br>Customer Photo <br>with Cross Sign</div>
                            </td>
                            
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Group Name </td><td style="border-width:2px"> {{seeRecord.collection_center.name}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Contact No </td><td style="border-width:2px"> {{seeRecord.member.mobile}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">DOB </td><td style="border-width:2px"> {{mem.dob | myDate}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Gender </td><td style="border-width:2px"> {{mem.gender}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Spouse Name  </td><td style="border-width:2px"> {{mem.spouseName}}</td>
                          </tr>
                          <!-- <tr style="border-width:2px">
                            <td style="border-width:2px">Father Name (C/O) </td><td style="border-width:2px"> {{mem.fatherName}}</td>
                          </tr> -->
                          <tr style="border-width:2px">
                            <td style="border-width:2px" colspan="2"><strong>Address Details</strong></td>
                            <td style="border-width:2px" colspan="2"></td>
                          </tr>
                          <tr>
                              <td style="border-width:2px"><strong>Address </strong></td><td style="border-width:2px"> {{mem.address}}, {{mem.area}}</td>
                              <td style="border-width:2px"><strong>District/State/Pincode </strong></td><td style="border-width:2px" v-if="mem.state"> {{mem.district}}, {{mem.state.name}} - {{mem.pin}}</td>
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px" colspan="2"><strong>Bank Details</strong></td>
                              <td style="border-width:2px" colspan="2"><strong>Applied Loan Details</strong></td>
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>Bank : </strong> <span v-if="mem.bank"> {{mem.bank.name}}</span> </td>
                              <td style="border-width:2px"><strong>Branch : </strong><span v-if="mem.bankBranch"> {{mem.bankBranch}}</span></td>
                              <td style="border-width:2px"><strong>Loan ID :</strong> <span v-if="seeRecord.member_loan_plan" >{{seeRecord.member_loan_plan.applicationNo}}</span> </td>
                              <td style="border-width:2px"><strong>Plan Name :</strong> {{pl.name}}</td>
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>Account Holder : </strong>{{mem.accountHolderName}}</td>
                              <td style="border-width:2px"><strong>Account Number : </strong> <span v-if="mem.accountNumber">{{mem.accountNumber}}</span></td>
                              <!-- <td style="border-width:2px"><strong>Interest Rate (%) :</strong> 22.7 </td> -->
                              <td style="border-width:2px"><strong v-if="pl.rateOfInterest > 0">Interest Rate (%) : {{pl.rateOfInterest}} </strong></td>
                              <td style="border-width:2px"> <strong>GST Include : </strong>{{pl.includeGst}}</td>
                              <!-- <td style="border-width:2px">Insurance Charge </td><td style="border-width:2px" v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td style="border-width:2px" v-else> {{pl.fileCharge}}</td> -->
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>IFSC : </strong>{{mem.ifsc}}</td>
                              <td style="border-width:2px"></td>
                              <td style="border-width:2px"><strong>Plan Amount :</strong> {{ planAmt(seeRecord) }}</td>
                              <td style="border-width:2px"><strong>File Charge : </strong>{{ fileChargeFee(seeRecord) }}</td>
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px" colspan="2"><strong>Income Details</strong></td>
                              <td style="border-width:2px"><strong>Processing Fee :</strong> {{ processingFee(seeRecord) }}</td>
                              <td style="border-width:2px"><strong>Insurance Fee :</strong> {{ insuranceFee(seeRecord) }}</td>
                            </tr>
                            <tr v-if="pl.rateOfInterest" style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>Income (INR) : </strong>{{mem.incomeAmount}}</td>
                              <td style="border-width:2px"><strong>Occupation : </strong>{{mem.jobType}}</td>
                              <td style="border-width:2px"><strong>Recovery type :</strong> {{pl.recoveryType}}</td>
                              <td style="border-width:2px"><strong>Amount to be Paid :</strong> <span v-if="seeRecord.loanAmount">{{seeRecord.loanAmount}}</span><span v-else> {{pl.amount}}</span></td>
                              
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>Business Name : </strong>{{mem.businessName}}</td>
                              <td style="border-width:2px"><strong>Income Type : </strong>{{mem.incomeType}}</td>
                              <td style="border-width:2px"><strong>No of Payments : </strong> <span v-if="pl.noOfPayments">{{pl.noOfPayments}}</span></td>
                              <td style="border-width:2px"> </td>
                            </tr>
                            <tr>
                              <td style="border-width:2px"><strong>Minimum Income : </strong>{{mem.minAmount}}</td>
                              <td style="border-width:2px"> </td>
                              <td style="border-width:2px"><strong>Purpose : </strong><span v-if="seeRecord.purpose">{{seeRecord.purpose.purpose}}</span></td>
                              <td style="border-width:2px"><strong>Description : </strong>{{seeRecord.description}}</td>
                            </tr>
                          <!-- </tbody>
                        </table>

                        <table class="table table-condensed" style="border-width:2px">
                          <tbody style="border-width:3px"> -->
                            <tr style="border-width:2px">
                              <td style="border-width:2px" colspan="3"><strong>Guarantor Details</strong></td>
                              <td style="border-width:2px" rowspan="3">
                                <div style="border-width:3px;border-style:solid;width:120px;height:140px;float:right;text-align:center;"><br><center>Guarantor Photo <br>with Cross Sign</center></div>
                              </td>
                            </tr>
                            <tr style="border-width:2px">
                              <td style="border-width:2px"><strong>Name </strong></td><td style="border-width:2px"> {{mem.guarantorName}}</td>
                              <td style="border-width:2px"><strong>Contact Number : </strong>{{mem.guarantorPhone}} </td>
                            </tr>
                            <tr style="border-width:2px">
                              <td style="border-width:2px"><strong>Address </strong></td><td style="border-width:2px"> {{mem.guarantorAddress}}</td>
                              <td style="border-width:2px"><strong>Narration : </strong>{{mem.guarantorNarration}}</td>
                            </tr>
                            <tr>
                              <td style="border-width:2px"><strong>Nominee Details</strong> </td>
                              <td style="border-width:2px"><strong>Nominee Name : </strong>{{mem.nomineeName}}</td>
                              <td style="border-width:2px"><strong>Contact Number : </strong>{{mem.nomineePhone}}</td>
                              <td style="border-width:2px"><strong>Nominee Dob : </strong>{{mem.nomineeDob}}</td>
                            </tr>
                        </tbody>
                      </table>
                      <p style="page-break-before: always;"></p>
                      <h3>Repayment Schedule Terms </h3>
                      
                      <table class="table table-condensed" style="border-width:2px">
                        <thead style="border-width:2px">
                          <tr style="border-width:2px">
                            <td style="border-width:2px"><strong>Sr. No</strong></td>
                            <td style="border-width:2px"><strong>EMI Date</strong></td>
                            <td style="border-width:2px"><strong>Interest</strong></td>
                            <td style="border-width:2px"><strong>Principal</strong></td>
                            <td style="border-width:2px"><strong>Amount</strong></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(memberEmiRecord) in memberEmiRecords" :key="memberEmiRecord.id" style="border-width:2px">
                            <td style="border-width:2px">{{memberEmiRecord.emiNo}}</td>
                            <td style="border-width:2px">{{memberEmiRecord.emiDate}}</td>
                            <td style="border-width:2px">{{memberEmiRecord.intrest}}</td>
                            <td style="border-width:2px">{{memberEmiRecord.principal}}</td>
                            <td style="border-width:2px">{{memberEmiRecord.total}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <p style="page-break-before: always;"></p>
                      <p>1. उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता है जो स्पष्ट करता है कि सर्च की पालना नहीं की गई है तो कंपनी को अधिकार है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे</p>
                      <p>2. मैं /हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई आर दर्ज है।</p>
                      <p>3. यह है कि मैं / हमें किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी से मुझे / हमको डिफॉल्टर घोषित नहीं किया गया है।</p>
                      <p>4. यह है कि मैं हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं हम भुगतान करने में देरी नहीं करेंगे।</p>
                      <p>5. यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा मैं उसके साथ विनम्र व्यवहार रखूंगा  रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी कर्मचारी तथा कंपनी हमारे प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे</p>
                      
                      <p>6. यह है कि मैं हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना फोन इत्यादि करने के लिए कंपनी जिम्मेदार नहीं होगी इस बात की याददाश्त संबंधित संपूर्ण जिम्मेदारी मेरी या  हमारी होगी</p>
                      <p>7. यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में लिखित प्रदान करेंगे</p>
                      <p>8. यह है कि मैं /हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों को बैंक में स्टॉप नहीं कराएंगे और ना ही उक्त चेक के खोने की रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आएंगे यदि हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी !</p>
                      <p>9. यह है कि कंपनी द्वारा के संग्रहण संबंधित जो सुविधाएं जैसे कि s.m.s. कॉलिंग मेल किया नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज अलग से मांगेंगे वह हम प्रदान करेंगे|</p>
                      <p>10. यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व  है अगर भविष्य में आवेदक के साथ  कोई आकस्मिक घटना मृत्यु या दिवालिया या गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया जाएगा</p>
                      <p>11. यह है कि हम मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे विरोध कानूनी कार्रवाई करने का अधिकार रखेगी मैं हम ने लोन के बारे में समस्त जानकारी जैसे ब्याज कथा किस्तों की राशि किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं हम पूरी तरह तैयार है और अगर मैं हम किस्त देने में देरी करते हैं तो उस पर लगने वाला अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा | </p>
                      <p>12. यह है कि मैं हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है किस बात से हम पहले से जानकार हैं | </p>
                      <p>13. यह है कि हम मैं अपनी किस्तों का भुगतान साप्ताहिक रूप में करना चाहता हूं | </p>
                      <p>14. यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं हम समय पर उपस्थित हो जाएंगे | </p>
                      <p>15. यह है कि मेरी सालाना आय ₹500000 से कम है उक्त एग्रीमेंट या लोन को करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो हवास में यह एग्रीमेंट कर रहे हैं | </p>
                      <p style="page-break-before: always;"></p>
                      <br><br>
                      <p>1. All the above parties agree on all the following terms and condition that the borrower will use this amount as
                        per the rules of microfinance and will not use this amount or any part of it for any other purpose. We also agree
                        that if the company finds any reason to explain which has not been complied with, the company has the right to
                        withdraw this loan amount or part thereof without any Will withdraw the concession.</p>
                      <p>2. I and my guarantor are not involved in any illegal act in the past and neither a criminal case is pending against
                        us in any court nor any FIR is registered in any police station.</p>
                      <p>3. That I/We are not burdened with any kind of loan from any financial institution, bank finance company, nor
                        have I/we been declared a defaulter from any financial institution, bank or finance company.</p>
                      <p>4. That I/we are fully capable of paying the entire instalments of the said loan and I/We shall not delay the
                        payment under any circumstances</p>
                      <p>5. That whichever employee of the company will come to collect the instalment amount, I will keep polite
                        behaviour with them and will not call him any kind of objectionable thing, will not try to harm or beat him in any
                        way nor will he be dirty against him. Will not allege behaviour or abusive language If any abusive behaviour is
                        done by us then company will be free to take legal action against us.</p>
                      <p>6. That I/We the company will not be responsible for giving notices, reminders and electronic information
                        phone etc. For the full payment of my instalments related to intimation of the due date of payment of the loan,
                        the entire responsibility related to this will be my / ours.</p>
                      <p>7. That if the Borrower (s) or the Guarantor (s) change their business, job, Domicile , Mobile number or email
                        Id, they shall give prior written notice to the company.</p>
                      <p>8. That I / We undertake to make a statement that if the instalments are paid by us in future through are paid by
                        us in future through cheque, then we will not make stop payment of the checks given in the bank nor report the
                        loss of the said check to the police station. Nor will we close that account, if we do so, the company will have the
                        right to take legal action against us.</p>
                      <p>9. This is during the Company’s storage related facilities Such as S.M.S. we will provide the additional service
                        charge required for providing the calling, email notice.</p>
                      <p>10. That the guarantor is fully responsible and liable as per this agreement, if any accidental event ,death or
                        insolvency or serious illness occurs with the application future, the entire loan shall be paid by the guarantor.</p>
                      <p>11. That all the information given by me/us to the company has been provided orally which is the true and
                        correct in which no false fact of any kind have been told , if any information is found to be false then the
                        company has the right to take legal action against us. I will keep all the information about the loan, Such as the
                        amount of interest. Instalment, the time of instalment and the time of repayment. I have been given complete
                        information by the company employee, we are fully prepared for all the above terms and condition and if
                        me/we delay in paying the instalment, then the additional burden of legal expanses and other expenses which
                        will come in future will be provided by us.</p>
                      <p>12. That all the documents submitted by me/us Such as Aadhar card, Pan card , Ration card, Driving license,
                        Bank Passbook and Photo have not been tampered with or any fake document has been submitted by us near in
                        future, if any document is found to be forged, we can be sued for 420 by the company, which we are already
                        aware of.</p>
                      <p>13. That me/we want to pay our instalments monthly.</p>
                      <p>14. That I/we shall be present in time as and when called for by the company for the payment of this loan and
                        acceptance of the arrears or any part thereof or for any other specified purpose. </p>
                      <p>15. That my annual income is less than 500000/-, we have not done any kind of intoxication while doing the said
                        agreement or loan, we are doing this agreement in full consciousness.</p>
                      <!-- <p>1.उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता है जो स्पष्ट करता है कि सर्च की पालना नहीं की गई है तो कंपनी को अधिकार है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे</p>
                      <p>2. मैं /हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई आर दर्ज है।</p>
                      <p>3. यह है कि मैं हम किसी भी वित्तीय संस्थान बैंक फाइनेंस कंपनी से किसी भी प्रकार का लोन का भार हमारे ऊपर नहीं है और ना ही किसी वित्तीय संस्थान बैंक या फाइनेंस कंपनी से मुझे हमको डिफॉल्टर घोषित किया गया है।</p>
                      <p>4. यह है कि मैं हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं हम भुगतान करने में देरी नहीं करेंगे।</p>
                      <p>5. यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा मैं उसके साथ विनम्र व्यवहार रखूंगा  रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी कर्मचारी तथा कंपनी हमारे प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे</p>
                      
                      <p>6. यह है कि मैं हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना फोन इत्यादि करने के लिए कंपनी जिम्मेदार नहीं होगी इस बात की याददाश्त संबंधित संपूर्ण जिम्मेदारी मेरी या  हमारी होगी</p>
                      <p>7. यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में लिखित प्रदान करेंगे</p>
                      <p>8. यह है कि मैं हम यह वचनबद्ध बयान करते हैं कि भविष्य में हमारे द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों को बैंक में स्टाफ नहीं कराएंगे और ना ही उक्त चेक के खोने की सूचना रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आएंगे यदि हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी</p>
                      <p>9. यह है कि कंपनी द्वारा के संग्रहण संबंधित जो सुविधाएं जैसे कि s.m.s. कॉलिंग मेल किया नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज अलग से मांगेंगे वह हम प्रदान करेंगे|</p>
                      <p>10. यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व  है अगर भविष्य में आवेदक के साथ  कोई आकस्मिक घटना मृत्यु या दिवालिया या गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया जाएगा</p>
                      <p>11. यह है कि हम मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे विरोध कानूनी कार्रवाई करने का अधिकार रखेगी मैं हम ने लोन के बारे में समस्त जानकारी जैसे ब्याज कथा किस्तों की राशि किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं हम पूरी तरह तैयार है और अगर मैं हम किस्त देने में देरी करते हैं तो उस पर लगने वाला अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा | </p>
                      <p>12. यह है कि मैं हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है किस बात से हम पहले से जानकार हैं | </p>
                      <p>13. यह है कि हम मैं अपनी किस्तों का भुगतान साप्ताहिक रूप में करना चाहता हूं | </p>
                      <p>14. यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं हम समय पर उपस्थित हो जाएंगे | </p>
                      <p>15. यह है कि मेरी सालाना आय ₹160000 से कम है उक्त एग्रीमेंट या लोन को करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो हवास में यह एग्रीमेंट कर रहे हैं | </p> -->

                      <br>
                      <p><table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      <br><br><br><br><br><br><br><br><br><br>

                      </div>
                      <div v-if="seeRecord.status == 'pending'">
                        <br><br>
                        <table class="table">
                          <thead>
                            <th>Application Date</th>
                            <th>Customer</th>
                            <th>Account Number</th>
                            <th>Guarantor Name</th>
                            <th>Plan Amount</th>
                            <th>Paid Amount</th>
                            <th v-show="pl.planType === 'normal'">No. of EMI</th>
                          </thead>
                          <tbody>
                            <td style="border-width:2px">{{seeRecord.disbursementDate | myDate}}</td>
                            <td style="border-width:2px"><i v-if="seeRecord.member">{{seeRecord.member.name}} ({{seeRecord.member.code}})</i></td>
                            <td style="border-width:2px">{{mem.accountNumber}}</td>
                            <td style="border-width:2px">{{mem.guarantorName}}</td>
                            <td style="border-width:2px" v-if="pl.planType === 'normalReduced' || pl.planType === 'special'">{{ pl.amount + pl.fileCharge + pl.processingFee }}</td>
                            <td style="border-width:2px" v-else>{{ pl.amount + (pl.fileCharge) + (pl.amount * pl.processingFee)/100 }}</td>
                            <td style="border-width:2px">{{pl.amount}}</td>
                            <td style="border-width:2px" v-show="pl.planType === 'normal'">{{pl.noOfPayments}}</td>
                          </tbody>
                        </table>
                        <br><br>
                        <table class="table" v-if="seeRecord.status == 'pending'">
                          <thead>
                            <th>Branch Manager Signature</th>
                            <th>Customer Signature</th>
                            <th>Date</th>
                          </thead>
                        </table>
                        <br><br>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintCustomerEMIModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printCustomerEMI()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            
            <div class="modal-body" id="printCustomerEMI">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table table-condensed">
                        <thead>
                          <td style="border-width:2px" width="18%"><img :src="logo" height="90"></td>
                          <td style="border-width:2px" class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td style="border-width:2px" class="text-right" width="20%"><barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <h1 class="text-center">Loan EMI Card</h1>
                      <div v-if="seeRecord.status == 'disbursed'">
                      <table class="table table-condensed">
                        <thead>
                          <th colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th colspan="2" class="text-right">Date : {{seeRecord.created_at | myDate}}</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="border-width:2px">Customer Name </td><td style="border-width:2px"> {{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td style="border-width:2px">Group Name </td><td style="border-width:2px"> {{seeRecord.collection_center.name}}</td>
                          </tr>
                          <tr>
                            <td style="border-width:2px">Contact No </td><td style="border-width:2px"> {{seeRecord.member.mobile}}</td>
                            <td style="border-width:2px">Spouse Name </td><td style="border-width:2px"> {{mem.spouseName}}</td>
                          </tr>
                          <tr>
                            <td style="border-width:2px"><strong>Plan Amount</strong></td>
                            <td style="border-width:2px">₹ {{planAmt(seeRecord) }}</td>
                            <td style="border-width:2px">Plan Name </td><td style="border-width:2px"> {{pl.name}} </td>
                          </tr>
                          <tr>
                            <td style="border-width:2px"><strong>Number of EMI </strong></td><td style="border-width:2px"> {{ pl.noOfPayments }}</td>
                            <td style="border-width:2px"><strong>EMI Amount - </strong></td><td style="border-width:2px"> ₹ {{memberFirstEmiRecord}}</td>
                            <!-- <td style="border-width:2px">Total Paid Amount </td><td style="border-width:2px"> {{memberTotalDueAmt}} </td> -->
                          </tr>
                          
                        </tbody>
                      </table>
                      
                      <h3>EMI Schedule Terms </h3>
                      
                      <table class="table table-condensed" style="border-width:2px">
                        <thead style="border-width:2px">
                          <tr style="border-width:2px;color:black">
                            <td style="border-width:2px;color:black"><strong>Sr. No</strong></td>
                            <td style="border-width:2px;color:black"><strong>Loan EMI Date</strong></td>
                            <td style="border-width:2px;color:black"><strong>Interest</strong></td>
                            <td style="border-width:2px;color:black"><strong>Principal</strong></td>
                            <td style="border-width:2px;color:black"><strong>Amount</strong></td>
                            <td style="border-width:2px;color:black"><strong>Remaining Amt</strong></td>
                            <td style="border-width:2px;color:black"><strong>Receiving Date</strong></td>
                            <td style="border-width:2px;color:black"><strong>Received Amt</strong></td>
                            <td style="border-width:2px;color:black"><strong>Staff Sign</strong></td>
                            <td style="border-width:2px;color:black"><strong>Senior Sign</strong></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(memberEmiRecord) in memberEmiRecords" :key="memberEmiRecord.id" style="border-width:2px;color:black">
                            <td style="border-width:2px;color:black">{{memberEmiRecord.emiNo}}</td>
                            <td style="border-width:2px;color:black">{{memberEmiRecord.emiDate | myDate}}</td>
                            <td style="border-width:2px;color:black">{{memberEmiRecord.intrest}}</td>
                            <td style="border-width:2px;color:black">{{memberEmiRecord.principal}}</td>
                            <td style="border-width:2px;color:black">{{memberEmiRecord.total}}</td>
                            <td style="border-width:2px;color:black">{{memberEmiRecord.memberDueAmt}}</td>
                            <td style="border-width:2px;color:black"></td>
                            <td style="border-width:2px;color:black"></td>
                            <td style="border-width:2px;color:black"></td>
                            <td style="border-width:2px;color:black"></td>
                          </tr>
                        </tbody>
                      </table>
                      <br>   
                      <br>
                      <p>
                        <table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      

                      </div>
                      
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintCustomerModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printCustomer()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printCustomer">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table table-condensed">
                        <thead>
                          <td style="border-width:2px" width="18%"><img :src="logo" height="90"></td>
                          <td style="border-width:2px" colspan="2" class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td style="border-width:2px" class="text-right" width="20%"><barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <h1 class="text-center">Loan Application Form</h1>
                      <div v-if="seeRecord.status == 'disbursed'">
                      <table class="table table-condensed">
                        <thead style="border-width:2px">
                          <th colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th colspan="2" class="text-right">Disbursment Date : {{seeRecord.disbursementDate | myDate}}</th>
                        </thead>
                        <tbody style="border-width:2px">
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Customer Name </td><td style="border-width:2px"> {{seeRecord.member.name}}  ({{seeRecord.member.code}})</td>
                            <td style="border-width:2px" rowspan="6" colspan="2">
                              <div style="border-width:3px;border-style:solid;width:150px;height:180px;float:right;text-align:center;"><br>Customer <br> & <br>Guarantor Photo <br>with Cross Sign</div>
                            </td>
                            
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Group Name </td><td style="border-width:2px"> {{seeRecord.collection_center.name}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Contact No </td><td style="border-width:2px"> {{seeRecord.member.mobile}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Adhar Number </td><td style="border-width:2px"> {{mem.aadharNo}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Gender </td><td style="border-width:2px"> {{mem.gender}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Spouse Name  </td><td style="border-width:2px"> {{mem.spouseName}}</td>
                          </tr>
                          <tr style="border-width:2px">
                            <td style="border-width:2px">Father Name (C/O)  </td><td style="border-width:2px"> {{mem.fatherName}}</td>
                            <td style="border-width:2px">Account Number</td>
                            <td style="border-width:2px">{{mem.accountNumber}}</td>
                          </tr>
                          
                          <tr style="border-width:2px">
                            <td style="border-width:2px" colspan="2"><strong>Address Details</strong></td>
                            <td style="border-width:2px" colspan="2"></td>
                          </tr>
                          <tr>
                              <td style="border-width:2px"><strong>Address </strong></td><td style="border-width:2px"> {{mem.address}}, {{mem.area}}</td>
                              <td style="border-width:2px"><strong>District/State/Pincode </strong></td><td style="border-width:2px" v-if="mem.state"> {{mem.district}}, {{mem.state.name}} - {{mem.pin}}</td>
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px" colspan="2"><strong>Bank Details</strong></td>
                              <td style="border-width:2px" colspan="2"><strong>Applied Loan Details</strong></td>
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>Bank : </strong> <span v-if="mem.bank"> {{mem.bank.name}}</span> </td>
                              <td style="border-width:2px"><strong>Branch : </strong><span v-if="mem.bankBranch"> {{mem.bankBranch}}</span></td>
                              <td style="border-width:2px"><strong>Loan ID :</strong> <span v-if="seeRecord.member_loan_plan" >{{seeRecord.member_loan_plan.applicationNo}}</span> </td>
                              <td style="border-width:2px"><strong>Plan Name :</strong> {{pl.name}}</td>
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>Account Holder : </strong>{{mem.accountHolderName}}</td>
                              <td style="border-width:2px"><strong>Account Number : </strong> <span v-if="mem.accountNumber">{{mem.accountNumber}}</span></td>
                              <td style="border-width:2px"><strong v-if="pl.rateOfInterest > 0">Interest Rate (%) : {{pl.rateOfInterest}} </strong></td>
                              <!-- <td style="border-width:2px"><strong>Interest Rate (%) :</strong> 22.7 </td> -->
                              <td style="border-width:2px"> <strong>GST Include : </strong>{{pl.includeGst}}</td>
                              <!-- <td style="border-width:2px">Insurance Charge </td><td style="border-width:2px" v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td style="border-width:2px" v-else> {{pl.fileCharge}}</td> -->
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>IFSC : </strong>{{mem.ifsc}}</td>
                              <td style="border-width:2px"></td>
                              <td style="border-width:2px"><strong>Plan Amount :</strong> {{ planAmt(seeRecord) }}</td>
                              <td style="border-width:2px"><strong>File Charge : </strong>{{ fileChargeFee(seeRecord) }}</td>
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px" colspan="2"><strong>Income Details</strong></td>
                              <td style="border-width:2px"><strong>Processing Fee :</strong> {{ processingFee(seeRecord) }}</td>
                              <td style="border-width:2px"><strong>Insurance Fee :</strong> {{ insuranceFee(seeRecord) }}</td>
                            </tr>
                            <tr v-if="pl.rateOfInterest" style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>Income (INR) : </strong>{{mem.incomeAmount}}</td>
                              <td style="border-width:2px"><strong>Occupation : </strong>{{mem.jobType}}</td>
                              <td style="border-width:2px"><strong>Recovery type :</strong> {{pl.recoveryType}}</td>
                              <td style="border-width:2px"><strong>Amount to be Paid :</strong> <span v-if="seeRecord.loanAmount">{{seeRecord.loanAmount}}</span><span v-else> {{pl.amount}}</span></td>
                              
                            </tr>
                            <tr style="border-width:2px;border-style:solid;">
                              <td style="border-width:2px"><strong>Business Name : </strong>{{mem.businessName}}</td>
                              <td style="border-width:2px"><strong>Income Type : </strong>{{mem.incomeType}}</td>
                              <td style="border-width:2px"><strong>No of Payments : </strong> <span v-if="pl.noOfPayments">{{pl.noOfPayments}}</span></td>
                              <td style="border-width:2px"> </td>
                            </tr>
                            <tr>
                              <td style="border-width:2px"><strong>Minimum Income : </strong>{{mem.minAmount}}</td>
                              <td style="border-width:2px"> </td>
                              <td style="border-width:2px"><strong>Purpose : </strong><span v-if="seeRecord.purpose">{{seeRecord.purpose.purpose}}</span></td>
                              <td style="border-width:2px"><strong>Description : </strong>{{seeRecord.description}}</td>
                            </tr>
                            <tr style="border-width:2px">
                              <td style="border-width:2px" colspan="3"><strong>Guarantor Details</strong></td>
                              <td style="border-width:2px" rowspan="3">
                                <div style="border-width:3px;border-style:solid;width:120px;height:140px;float:right;text-align:center;"><br><center>Guarantor Photo <br>with Cross Sign</center></div>
                              </td>
                            </tr>
                            <tr style="border-width:2px">
                              <td style="border-width:2px"><strong>Name </strong></td><td style="border-width:2px"> {{mem.guarantorName}}</td>
                              <td style="border-width:2px"><strong>Contact Number : </strong>{{mem.guarantorPhone}} </td>
                            </tr>
                            <tr style="border-width:2px">
                              <td style="border-width:2px"><strong>Address </strong></td><td style="border-width:2px"> {{mem.guarantorAddress}}</td>
                              <td style="border-width:2px"><strong>Narration : </strong>{{mem.guarantorNarration}}</td>
                            </tr>
                            <tr>
                              <td style="border-width:2px"><strong>Nominee Details</strong> </td>
                              <td style="border-width:2px"><strong>Nominee Name : </strong>{{mem.nomineeName}}</td>
                              <td style="border-width:2px"><strong>Contact Number : </strong>{{mem.nomineePhone}}</td>
                              <td style="border-width:2px"><strong>Nominee Dob : </strong>{{mem.nomineeDob}}</td>
                            </tr>
                          
                        </tbody>
                      </table>
                      </div><br><br><br><br><br>
                      <p><table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      
                      
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Loan Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Branch Name</b>

                          <a class="pull-right">{{ seeRecord.branch.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Branch Code</b>
                          <a class="pull-right">{{
                            seeRecord.branch.branchCode
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Name</b>
                          <a class="pull-right">{{ seeRecord.agent.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Code</b>
                          <a class="pull-right">{{ seeRecord.agent.code }}</a>
                        </li>

                        <li class="list-group-item">
                          <b>Plan Details</b>
                          <table
                            class="table table-sm table-striped table-dark"
                          >
                            <tr style="border-width:2px">
                              <td><b>Plan Name </b> : {{ pl.name }}</td>
                              <td><b>Plan Type </b> : {{ pl.planType }}</td>
                            </tr>
                            <tr style="border-width:2px">
                              <td>
                                <b>Type of Interest</b> : {{ pl.typeOfInterest }}
                              </td>
                              <td>
                                <!-- <b>Tenure </b>: Year - {{ pl.tenureYear }},
                                Month - {{ pl.tenureMonth }}, Day -
                                {{ pl.tenureDay }} -->
                              </td>
                            </tr>
                            <tr style="border-width:2px">
                              <td>
                                <b>Recovery Type</b> : {{ pl.recoveryType }}
                              </td>
                              <td>
                                <b>Number of Payments</b> :
                                {{ pl.noOfPayments }}
                              </td>
                            </tr>
                            <tr style="border-width:2px">
                              <td><b>Amount</b> : {{ pl.amount }}</td>
                              <td>
                                <b>Advance Installment</b> :
                                {{ pl.acvanceInstallment }}
                              </td>
                            </tr>
                            <tr style="border-width:2px">
                              <td><b>Panulty </b>: {{ pl.panulty }}</td>
                              <td>
                                <b>Processing Fee </b>: {{ pl.processingFee }}
                              </td>
                            </tr>
                            <tr style="border-width:2px">
                              <td><b>File Charge</b> : {{ pl.fileCharge }}</td>
                              <td v-if="pl.created_by">
                                <b>Created By</b> : {{ pl.created_by.name }}
                              </td>
                            </tr>
                          </table>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.member_id">
                          <b>Member Name</b>
                          <a class="pull-right">{{ seeRecord.member.name }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Plan Type</b>
                          <a class="pull-right">{{ seeRecord.planType }}</a>
                        </li>

                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Name</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.name
                          }}</a>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.centerCode
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.name
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.code
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Disbursement Date</b>
                          <a class="pull-right">{{
                            seeRecord.disbursementDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>EMI Start Date</b>
                          <a class="pull-right">{{
                            seeRecord.emiStartDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Payment Mode</b>
                          <a class="pull-right">{{ seeRecord.paymentMode }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Status</b>
                          <a class="pull-right">{{ seeRecord.status }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <!-- Demand Probeshnary note  -->
      <printviewdisbursementcollectioncenterwise :seeRecords="this.seeRecords" :branch="branch" :collectionCenter="collectionCenter" :getCompanyRecord="getCompanyRecord" :logo="logo"></printviewdisbursementcollectioncenterwise>
      <!-- /.modal -->
      <!-- Demand Probeshnary note  -->
      <demandprobeshnarynote :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo" :pl="pl" :mem="mem"></demandprobeshnarynote>
      <!-- /.modal -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
var _ = require('lodash')
import BranchWiseCollectionCenter from '../../mixins/BranchWiseCollectionCenterData'
import DisbursementByCollectionCenter from '../../mixins/DisbursementByCollectionCenter'
import VueBarcode from 'vue-barcode'
import printviewdisbursementcollectioncenterwise from '../components/PrintViewDisbursementCollectionCenterWise.vue'
import demandprobeshnarynote from '../components/DemandProbeshnaryNote.vue'
export default {
  name: 'my-component',
  mixins: [BranchWiseCollectionCenter, DisbursementByCollectionCenter],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      branch: {},
      per_page: 10,
      table_search: '',
      totalAmt: 0,
      editMode: false,
      logo: '',
      adhar: '',
      mem: {},
      memberTotalDueAmt: null,
      collectionCenters: [],
      collectionCenter: {},
      branches: [],
      members: [],
      memberEmiRecords: [],
      memberFirstEmiRecord: null,
      staffs: {},
      bank_accounts: [],
      pl: {},
      seeRecord: {},
      seeRecords: [],
      loanplans: [],
      processingFeeType: '',
      insuranceFeeType: '',
      groupMembers: {},
      getCompanyRecord: {},
      viewCollectionCenter: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        plan: {},
        planType: 'individual',
        status: '',
        branch_ledger_id: '',
        disbursement_id: '',
        disbursementStartDate: '',
        disbursementEndDate: '',
        startEmiEndDate: '',
        endEmiEndDate: '',
        emiStartDate: '',
        processingFee: null,
        insuranceFee: null,
        fileCharge: null,
        amt: '',
        type: '',
        paymentDate: null
      }),
      // columns: [
      //   {
      //     label: 'PLAN Name',
      //     field: 'plan_name'
      //   },
      //   {
      //     label: 'Amount',
      //     field: 'plan_amt'
      //   },
      //   {
      //     label: 'Dis. Date',
      //     field: 'DisbursementDate'
      //   },
      //   {
      //     label: 'Start Date',
      //     field: 'EmiStartDate'
      //   },
      //   {
      //     label: 'End Date',
      //     field: 'EmiEndDate'
      //   },
      //   {
      //     label: 'Group Name',
      //     field: 'collection_center.name'
      //   },
      //   {
      //     label: 'MEMBER',
      //     field: 'member.name'
      //   },
      //   {
      //     label: 'AGENT',
      //     field: 'agent.name'
      //   },
      //   {
      //     label: 'MODE',
      //     field: 'branch_ledger.ledger.name'
      //   },
      //   {
      //     label: 'STATUS',
      //     field: 'Status'
      //   },
      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: []
    }
  },
  components: {
    'barcode': VueBarcode,
    demandprobeshnarynote,
    printviewdisbursementcollectioncenterwise
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      return pln.name
    },
    planRecoveryType (plan) {
      var pln = JSON.parse(plan)
      return pln.recoveryType
    },
    planAmt (row) {
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    getRecordByCollectionCenter (collectionCenter) {
      this.form.collection_center_id = ''
      if (collectionCenter) {
        this.form.collection_center_id = collectionCenter.id
        this.form.branch_id = collectionCenter.branch_id
      }
      this.changeFilter()
    },
    fileChargeModal (row) {
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#fileChargeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'fileCharge'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.includeGst === 'true') {
        this.form.amt = row.fileCharge ? row.fileCharge + (row.fileCharge * 18 / 100) : this.pl.fileCharge + (this.pl.fileCharge * 18 / 100)
      } else {
        this.form.amt = row.fileCharge ? row.fileCharge : this.pl.fileCharge
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    processingFeeModal (row) {
      var pfamt = 0
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#processingFeeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'processingFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.processingFeeType === 'percent') {
        pfamt = row.loanAmount ? (this.pl.processingFee * row.loanAmount / 100) : (this.pl.processingFee * this.pl.amount / 100)
        if (this.pl.includeGst === 'true') {
          this.form.amt = pfamt + pfamt * 18 / 100
        } else {
          this.form.amt = pfamt
        }
      }
      if (this.pl.processingFeeType === 'fixed') {
        pfamt = row.processingFee ? row.processingFee : this.pl.processingFee
        if (this.pl.includeGst === 'true') {
          this.form.amt = pfamt + pfamt * 18 / 100
        } else {
          this.form.amt = pfamt
        }
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    insuranceFeeModal (row) {
      var ifamt = 0
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#insuranceFeeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'insuranceFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.insuranceFeeType === 'percent') {
        ifamt = row.loanAmount ? (this.pl.insuranceFee * row.loanAmount / 100) : (this.pl.insuranceFee * this.pl.amount / 100)
        if (this.pl.includeGst === 'true') {
          this.form.amt = ifamt + ifamt * 18 / 100
        } else {
          this.form.amt = ifamt
        }
      }
      if (this.pl.insuranceFeeType === 'fixed') {
        ifamt = row.insuranceFee ? row.insuranceFee : this.pl.insuranceFee
        if (this.pl.includeGst === 'true') {
          this.form.amt = ifamt + ifamt * 18 / 100
        } else {
          this.form.amt = ifamt
        }
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    // file charge and processing fee collection
    fileChargeProcessingFeeCollect () {
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
        this.$delete(this.form, 'center_leader_id')
      }
      this.$axios
        .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.disbursementStartDate = ''
          this.form.disbursementEndDate = ''
          this.form.startEmiEndDate = ''
          this.form.endEmiEndDate = ''
          this.form.branch_id = ''
          this.changeFilter()
          if (this.form.type === 'fileCharge') {
            $('#fileChargeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'File Charge Paid Successfully'
            })
          }
          if (this.form.type === 'processingFee') {
            $('#processingFeeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Processing Fee Paid Successfully'
            })
          }
          if (this.form.type === 'insuranceFee') {
            Fire.$emit('AfterCreate')
            $('#insuranceFeeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Insurance Fee Paid Successfully'
            })
          }
          Fire.$emit('AfterCreate')
        })
    },
    fileChargeFee (row) {
      var fcamt
      var pln = JSON.parse(row.plan)
      fcamt = row.fileCharge ? row.fileCharge : pln.fileCharge
      if (pln.includeGst === 'true') {
        return fcamt + fcamt * 18 / 100
      } else {
        return fcamt
      }
    },
    processingFee (row) {
      var pfamt
      var pln = JSON.parse(row.plan)
      if (pln.processingFeeType === 'percent') {
        pfamt = row.loanAmount ? (pln.processingFee * row.loanAmount / 100) : (pln.processingFee * pln.amount / 100)
        if (pln.includeGst === 'true') {
          return pfamt + pfamt * 18 / 100
        } else {
          return pfamt
        }
      }
      if (pln.processingFeeType === 'fixed') {
        pfamt = row.processingFee ? row.processingFee : pln.processingFee
        if (pln.includeGst === 'true') {
          return pfamt + pfamt * 18 / 100
        } else {
          return pfamt
        }
      }
    },
    insuranceFee (row) {
      var ifamt
      var pln = JSON.parse(row.plan)
      if (pln.insuranceFeeType === 'percent') {
        ifamt = row.loanAmount ? (pln.insuranceFee * row.loanAmount / 100) : (pln.insuranceFee * pln.amount / 100)
        if (pln.includeGst === 'true') {
          return ifamt + ifamt * 18 / 100
        } else {
          return ifamt
        }
      }
      if (pln.insuranceFeeType === 'fixed') {
        ifamt = row.insuranceFee ? row.insuranceFee : pln.insuranceFee
        if (pln.includeGst === 'true') {
          return ifamt + ifamt * 18 / 100
        } else {
          return ifamt
        }
      }
    },
    viewPrintModal (row) {
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintModal').modal({backdrop: 'static', keyboard: false})
      this.$axios
        .get('memberemi?all=all&disbursement_id=' + row.id + '&member_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log('get member emi records')
          // console.log(data.data)
          this.memberEmiRecords = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
      )
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      if (this.pl.planType === 'custom') {
        this.pl.noOfPayments = _.sumBy(this.pl.plan_details, function (o) { return parseInt(o.noOfPayments) })
      }
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewPrintCustomerEMIModal (row) {
      this.memberTotalDueAmt = 0
      var mTotalDueAmt = 0
      var fpi = 0
      var gstAmt = 0
      this.pl = JSON.parse(row.plan)
      if (this.pl.planType !== 'normal') {
        if (this.pl.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(this.pl.fileCharge)
        }
        if (this.pl.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(this.pl.processingFee)
        }
        if (this.pl.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(this.pl.insuranceFee)
        }
        if (this.pl.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        mTotalDueAmt = row.loanAmount ? row.loanAmount + fpi : this.pl.amount + fpi
      } else {
        mTotalDueAmt = row.loanAmount ? row.loanAmount : this.pl.amount
      }
      this.$axios
        .get('memberloanplan?disbursement_id=' + row.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberTotalDueAmt = data.data.data[0].totalAmt
          this.$axios
          .get('memberemi?all=all&disbursement_id=' + row.id + '&member_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.memberEmiRecords = data.data
            this.memberFirstEmiRecord = data.data[0].total
            $.each(this.memberEmiRecords, function (key, value) {
              this.memberEmiRecords[key].memberDueAmt = mTotalDueAmt - this.memberEmiRecords[key].principal
              mTotalDueAmt = mTotalDueAmt - this.memberEmiRecords[key].principal
            }.bind(this))
          }).catch(function (error) { console.log(error) })
        }).catch(function (error) { console.log(error) })
      this.form.reset()
      this.loadCompanyProfile()
      this.seeRecord = row
      $('#viewPrintCustomerEMIModal').modal({backdrop: 'static', keyboard: false})
      if (this.pl.planType === 'custom') {
        this.pl.noOfPayments = _.sumBy(this.pl.plan_details, function (o) { return parseInt(o.noOfPayments) })
      }
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    showPlanAmtNormal (pl) {
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount
      } else {
        return pl.amount
      }
    },
    showPlanAmtReduced (pl) {
      if (this.seeRecord.loanAmount) {
        return this.seeRecord.loanAmount + this.seeRecord.fileCharge + this.seeRecord.processingFee
      } else {
        return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      }
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
    },
    viewPrintCustomerModal (row) {
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintCustomerModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      if (this.pl.planType === 'custom') {
        this.pl.noOfPayments = _.sumBy(this.pl.plan_details, function (o) { return parseInt(o.noOfPayments) })
      }
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
          this.adhar = (this.mem.aadharNo !== null) ? this.mem.aadharNo.replace(/\d(?=\d{4})/g, '*') : ''
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: error })
            // this.form.errors.errors = error.response.data.error
          }
        )
    },
    viewPrintDimandProbeshnoryNote (row) {
      this.seeRecord = row
      this.loadCompanyProfile()
      $('#viewPrintDimandProbeshnoryNote').modal({backdrop: 'static', keyboard: false})
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteDisbursment (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('disbursement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    viewModal (row) {
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
    },
    getBranchMember () {
      this.form.member_id = this.mem.user_id
    },
    getBranchCollectionCenter () {
      this.form.collection_center_id = this.colC.id
      this.loadGroupMember(this.form.collection_center_id)
    },
    getBranchBankAccount (id) {
      this.$axios
        .get('branchledger?all=all&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.bank_accounts = data.data
          $.each(this.bank_accounts, function (key, value) {
            this.bank_accounts[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')

              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getSelectPlan () {
      // alert(this.form.plan.id)
      this.form.plan_id = this.form.plan.id
    },
    getPlanType () {
      this.form.center_leader_id = null
      this.form.collection_center_id = null
      this.form.member_id = null
    },
    loadStaff () {
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadLoan () {
      this.$axios
        .get('loanplan?all=all&status=true', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadGroupMember (id) {
      this.$axios
        .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupMembers = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    print () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('print').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    printCustomer () {
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Get HTML to print from element
      const prtHtml = document.getElementById('printCustomer').innerHTML

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    printCustomerEMI () {
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Get HTML to print from element
      const prtHtml = document.getElementById('printCustomerEMI').innerHTML

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    changeFilter (page = null, pg = null) {
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'disbursement'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          pageUrl += `&branch_id=${c.agent_profile.branch_id}`
        } else {
          pageUrl += `&agent_id=${c.id}`
        }
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      if (this.form.disbursementStartDate) {
        pageUrl += `&disbursementStartDate=${this.form.disbursementStartDate}`
      }
      if (this.form.disbursementEndDate) {
        pageUrl += `&disbursementEndDate=${this.form.disbursementEndDate}`
      }
      if (this.form.startEmiEndDate) {
        pageUrl += `&startEmiEndDate=${this.form.startEmiEndDate}`
      }
      if (this.form.endEmiEndDate) {
        pageUrl += `&endEmiEndDate=${this.form.endEmiEndDate}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.form.collection_center_id) {
        pageUrl += `&collection_center_id=${this.form.collection_center_id}`
      }
      this.$axios
        .get(`${pageUrl}&status=disbursed&searchTerm=group`, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.rows = data.data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    }
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.totalAmt = 0
    //   this.$axios
    //     .get('disbursement?all=all&status=disbursed&searchTerm=group&disbursementStartDate=' + this.form.disbursementStartDate + '&disbursementEndDate=' + this.form.disbursementEndDate + '&startEmiEndDate=' + this.form.startEmiEndDate + '&endEmiEndDate=' + this.form.endEmiEndDate + '&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //       _.forEach(this.rows, function (row, key) {
    //         if (row.loanAmount > 0) {
    //           this.totalAmt += row.loanAmount
    //         } else {
    //           this.totalAmt += parseInt(JSON.parse(row.plan).amount)
    //         }
    //       }.bind(this))
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // }
  },

  created () {
    // this.loadMember()

    this.changeFilter()
    this.loadBranch()
    this.loadLoan()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
  @media print {
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  table, tbody, tr, tr, td {
    border: 1px solid black;
  }
  .content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 10px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// GroupMemberDisbursment.vue?7486bd06